export const carouselConfig = {
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 1,
  centerMode: false,
  speed: 500,      
  nextArrow: null,
  prevArrow: null,
  responsive: [
    {
      breakpoint: 1214,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 894,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
  ],
};
